import { isBrowser } from 'ws-scripts/modules/environment';

const isDealerDotComImage = (uri) => uri.includes('dealer.com');

const hasExistingImpolicyParam = (uri) => uri.includes('impolicy=');

const imageCaches = new Map();

export const clearImageCaches = () => imageCaches.clear();

const getImageWidth = (threeUpDisplay, width, uri, threeUpRatio = 1) => {
	// Divide the width by 3 when the carousel is displaying 3 images
	const imageWidth = threeUpDisplay ? (width / 3) * threeUpRatio : width;
	let resizeWidth;

	// Set breakpoints so that we're only caching a limited # of image sizes
	switch (true) {
		case imageWidth <= 320:
			resizeWidth = 320; // iPhone 5
			break;
		case imageWidth <= 414:
			resizeWidth = 414; // iPhone 6/7/8 Plus
			break;
		case imageWidth <= 768:
			resizeWidth = 768; // iPad
			break;
		default:
			resizeWidth = 1024;
	}

	// Only cache on browser side. Caching on server can cause memory leak
	if (isBrowser) {
		imageCaches.set(uri, resizeWidth);
	}

	return resizeWidth;
};

const imageResizer = (threeUpDisplay, width, uri, threeUpRatio = 1) => {
	if (!uri || !isDealerDotComImage(uri) || hasExistingImpolicyParam(uri)) {
		return uri;
	}

	const resizeWidth = imageCaches.has(uri)
		? imageCaches.get(uri)
		: getImageWidth(threeUpDisplay, width, uri, threeUpRatio);

	return `${uri}?impolicy=resize&w=${resizeWidth}`;
};

export default imageResizer;
